<template>
  <sfs-form-modal
    :id="modalId"
    :title="`Edit ${value.name}`"
    @on-hide="resetFormData"
    class="text-left"
    size="sm"
  >
    <commission-plans-form
      :new-form="false"
      v-bind="value"
      @on-submit="update"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import CommissionPlansForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CommissionPlansEditModal',
  mixins: [formModalMixin],
  components: {
    CommissionPlansForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: `commission-plans-${this.value.id}-edit-modal`,
    };
  },
  methods: {
    update(data, handleUpdate) {
      handleUpdate(this.$commissionPlansAPI.update(this.value.id, data));
    },
    onSave(commissionPlan) {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save', commissionPlan);
    },
  },
};
</script>
